module.exports = __webpack_public_path__ + "static/media/aggregate-3.04376c6f.png";